import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../providers/AuthProvider";
import { paths } from "./paths";

function PublicOnlyRoute() {
  const { signed } = useAuth();

  return signed ? <Navigate to={paths.projects} replace /> : <Outlet />;
}

export default PublicOnlyRoute;
